import React, { FC, useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Img, Spinner } from "../../components";

import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step5 from "./step5";
import Cancel from "models/Cancel";
import { customerRegistrationSteps } from "../../utils";
import { Toaster, toast } from "sonner";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { AxiosRequestConfig } from "axios";
import {
  setCurrVerifyStep,
  setEmail,
  setPhone,
  setPanfront,
  setPanfrontBinary,
  setPanNumber,
  setCustomersId,
  setadhaarFront,
  setadhaarFrontBinary,
  setadhaarBack,
  setadhaarBackBinary,
  setAadharNumber,
  setCanceledCheque,
  setCanceledChequeBinary,
  setAccountNo,
  setAccountNoRe,
  setBankName,
  setIrfcCode,
  setPanName,
  setNameConsent,
} from "../../redux/features/CustomerRegistration/index";
import "react-toastify/dist/ReactToastify.css";
// Same signatures, answered by the new backend, which reads the documents
// through Cashfree. See legacy-customer-registration-api.ts. The two OTP
// endpoints are gone: their modal was already unreachable, and the desk
// photographs what is handed across the counter.
import {
  PostCustomerRegistrationStep1RequestType,
  postCustomerRegistrationStep1,
  PostCustomerRegistrationStep2RequestType,
  PostCustomerRegistrationStep2FallbackReqType,
  POSTPanVerifyFallback,
  POSTAadhaarVerifyFallback,
  PostCustomerRegistrationStep3FallbackReqType,
  PostCustomerRegistrationStep3RequestType,
  postCustomerRegistrationStep3,
  PostCustomerRegistrationStep4RequestType,
  postCustomerRegistrationStep4,
  POSTPanVerify,
  getStepsViaCustomerId as GetStepsViaCustomerId,
  postNameMismatchUpdate,
  PostNameMismatchUpdateRequestType,
} from "service/moneeflo/legacy-customer-registration-api";
import { useLocation, useNavigate } from "react-router-dom";
import Aadhaarpopup from "models/aadhaarpopup";
import Panpopup from "models/Panpopup";
import Navbar from "components/Navbar/Index";
import Stepper from "components/Stepper/newstepper";
import FormPopup from "./PANandAadhaarPopup/formpopup";
export const CustomFromContext = React.createContext<any>({ form: {} });

const CustomerRegistration: FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [type, setType] = useState<string>("");
  const [showaadhaarpopup, setShowaadhaarpopup] = useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [showpanpopup, setShowpanpopup] = useState<boolean>(false);
  const [verifypandetails, setVerifypandetails] = useState<any>({
    masked_pan_no: "",
    name: "",
  });
  const [aadhaarverifydetails, setAadhaarverifydetails] = useState<any>({
    masked_aadhaar_no: "",
    dob: "",
    name: "",
    address: "",
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [confirmCancel, setConfirmCancel] = useState(false);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const email = useAppSelector((state) => state.CustomerRegistration.email);
  const phone = useAppSelector((state) => state.CustomerRegistration.phone);
  const passport_number = useAppSelector(
    (state) => state.CustomerRegistration.passport_number,
  );
  const currverifystep = useAppSelector(
    (state) => state.CustomerRegistration.currverifystep,
  );
  const PanfrontBinary = useAppSelector(
    (state) => state.CustomerRegistration.PanfrontBinary,
  );
  const PanNumber = useAppSelector(
    (state) => state.CustomerRegistration.PanNumber,
  );
  const customers_id = useAppSelector(
    (state) => state.CustomerRegistration.customers_id,
  );
  const AadharFrontBinary = useAppSelector(
    (state) => state.CustomerRegistration.adhaarFrontBinary,
  );
  const AadharBackBinary = useAppSelector(
    (state) => state.CustomerRegistration.adhaarBackBinary,
  );
  const AadharNumber = useAppSelector(
    (state) => state.CustomerRegistration.aadhar_number,
  );
  const CanceledChequeBinary = useAppSelector(
    (state) => state.CustomerRegistration.Canceled_ChequeBinary,
  );
  const AccountNo = useAppSelector(
    (state) => state.CustomerRegistration.account_no,
  );
  const BankName = useAppSelector(
    (state) => state.CustomerRegistration.bank_name,
  );
  const IrfcCode = useAppSelector(
    (state) => state.CustomerRegistration.irfc_code,
  );
  const name_consent = useAppSelector(
    (state) => state.CustomerRegistration.name_consent,
  );

  const pan_name = useAppSelector(
    (state) => state.CustomerRegistration.pan_name,
  );
  const contact_id = useAppSelector(
    (state) => state.CustomerRegistration.contact_id,
  );

  useEffect(() => {
    async function fetchCurrentStep() {
      const payload = {
        params: {
          customers_id: location?.state?.contactID
        }
      }
      try {
        const data = await GetStepsViaCustomerId(payload)
        if (data?.data?.step) {
          setCurrentStep(data.data.step)
          dispatch(setCustomersId(location?.state?.contactID))
        }
      } catch (error) {

      }
    }
    fetchCurrentStep();
  }, [])
  // Step-1 API
  const step1API = (): void | null => {
    // get auth token from localstorage
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostCustomerRegistrationStep1RequestType> = {
      data: {
        email: email,
        number: location?.state?.pathName === "ContactPage" ? "" : phone,
        passport_no: passport_number,
        contacts_id: contact_id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    setLoading(true);
    postCustomerRegistrationStep1(req)
      .then((res) => {
        setLoading(false);
        dispatch(setCustomersId(res.data.id));

        // A number already on file is not an error — it is the same human,
        // and a second record for them is worse than resuming this one.
        // But say so, because the desk asked for a new customer and is
        // about to be shown someone else's half-finished registration.
        if (res.data.existing) {
          const who = res.data.existingName
            ? `${res.data.existingName} is`
            : "A customer is";
          toast.info(
            res.data.existingVerified
              ? `${who} already registered with this number. Opening their record.`
              : `${who} already on file with this number. Continuing their registration.`,
          );
        }
        setCurrentStep(currentStep + 1);

        dispatch(setCurrVerifyStep(currentStep));
      })
      .catch((err) => {
        // Never toast `undefined`: a thrown error carries no `response`,
        // and an empty black box tells the desk nothing at all.
        toast.error(
          err?.response?.data?.message ||
            err?.message ||
            "Could not start the registration. Please try again.",
        );
        setLoading(false);
      });
  };

  const step2API = (): void | null => {
    // get auth token from localstorage
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostCustomerRegistrationStep2RequestType> = {
      data: {
        pan_card: PanfrontBinary,
        pan_no: PanNumber,
        customers_id: customers_id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    setLoading(true);

    POSTPanVerify(req)
      .then((res: any) => {
        setLoading(false);
        dispatch(setCurrVerifyStep(currentStep));
        // Use result1.full_name for PAN name
        const panName = res.data?.result1?.full_name || res.data.full_name || "";
        setVerifypandetails({
          masked_pan_no: res.data.pan_no,
          name: panName,
        });
        setPanName(panName);
        setShowpanpopup(true);
      })
      .catch((err) => {
        setLoading(false);
        if (
          err.response.data.message ===
          "Other customer is registered with this pan"
        ) {
          toast.error("Other customer is registered with this pan");
          return;
        }
        setType("PAN");
        setDialogOpen(true);
      });
  };

  const step2fallback = async (data: { PAN: string; name: string }) => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostCustomerRegistrationStep2FallbackReqType> =
    {
      data: {
        customers_id,
        pan_no: data?.PAN,
        name: data?.name,
        pan_card: PanfrontBinary,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    setLoading(true);
    try {
      const response = await POSTPanVerifyFallback(req);
      if (response.status === 200) {
        setLoading(false);
        dispatch(setCurrVerifyStep(currentStep));
        setDialogOpen(false);
        setLoading(false);
        setCurrentStep((currentStep) => currentStep + 1);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error?.response.data.message);
    }
  };

  const step3API = (): void | null => {
    // get auth token from localstorage
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostCustomerRegistrationStep3RequestType> = {
      data: {
        aadhar_front: AadharFrontBinary,
        aadhar_back: AadharBackBinary,
        customers_id: customers_id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    setLoading(true);
    postCustomerRegistrationStep3(req)
      .then((res: any) => {
        setLoading(false);

        // Extract Aadhaar number from adhaar.front.document_fields.uid and mask it (show last 4 digits)
        const aadhaarUid = res.data?.adhaar?.front?.document_fields?.uid || "";
        const maskedAadhaar = aadhaarUid
          ? `**** **** ${aadhaarUid.slice(-4)}`
          : "**** **** ****";

        // Extract name for mismatch check
        const aadhaarName = res.data?.adhaar?.front?.document_fields?.name || "";

        // Extract DOB from adhaar.front.document_fields.dob
        const dob = res.data?.adhaar?.front?.document_fields?.dob || "";

        // Extract address from adhaar.back.document_fields.address
        const address = res.data?.adhaar?.back?.document_fields?.address || "";

        setAadhaarverifydetails({
          masked_aadhaar_no: maskedAadhaar,
          name: aadhaarName,
          dob: dob,
          address: address,
        });
        setShowaadhaarpopup(true);
      })
      .catch((err) => {
        setLoading(false);
        setType("aadhaar");
        setDialogOpen(true);
      });
  };

  const step3fallback = async (data: {
    aadhaar_number: string;
    name: string;
    date_of_birth: string;
    address: string;
  }) => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostCustomerRegistrationStep3FallbackReqType> =
    {
      data: {
        customers_id,
        aadhar_number: data?.aadhaar_number,
        name: data?.name,
        date: data?.date_of_birth,
        address: data?.address,
        aadhar_front_img: AadharFrontBinary,
        aadhar_back_img: AadharBackBinary,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    setLoading(true);
    try {
      const response = await POSTAadhaarVerifyFallback(req);
      if (response.status === 200) {
        setLoading(false);
        dispatch(setCurrVerifyStep(currentStep));
        setDialogOpen(false);
        setLoading(false);
        step4API();
        handleonCancel(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error?.response.data.message);
    }
  };

  const nameMismatchUpdateAPI = async (): Promise<void> => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostNameMismatchUpdateRequestType> = {
      data: {
        customers_id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    try {
      await postNameMismatchUpdate(req);
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to update name mismatch");
      throw err;
    }
  };

  const step4API = (): void | null => {
    // get auth token from localstorage
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostCustomerRegistrationStep4RequestType> = {
      data: {
        customers_id,
        cancel_cheque: CanceledChequeBinary,
        bank_account_no: AccountNo,
        bank_name: BankName,
        ifsc_code: IrfcCode,
        nameMismatch: name_consent,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    setLoading(true);
    postCustomerRegistrationStep4(req)
      .then((res) => {
        localStorage.setItem("ApplicationId", res.data.id.toString());
        localStorage.setItem("ApplicationStatus", res.data.status.toString());
        localStorage.removeItem("AlreadyReloaded");
        setLoading(false);
        navigate(`/customerdetails/${res?.data?.id}`);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setLoading(false);
      });
  };

  const handleNext = () => {
    if (currentStep === 1) {
      if (phone === "") {
        toast.error("Please Enter All Details");
        return;
      } else if (phone.length != 10) {
        toast.error("Please Enter valid phone number");
        return;
      }
      if (currverifystep >= currentStep) {
        setCurrentStep(currentStep + 1);
      } else {
        step1API();
      }
    } else if (currentStep === 2) {
      if (PanfrontBinary === "" || PanNumber === "") {
        toast.error("Please enter PAN details");
        return;
      }
      if (currverifystep >= currentStep) {
        setCurrentStep(currentStep + 1);
      } else {
        step2API();
      }
    } else if (currentStep === 3) {
      if (
        AadharFrontBinary === "" ||
        AadharBackBinary === ""
      ) {
        toast.error("Please enter Aadhaar details");
        return;
      }
      if (currverifystep >= currentStep) {
        setCurrentStep(currentStep + 1);
      } else {
        step3API();
      }
    }
  };

  const handleonCancel = (naviagte = true) => {
    dispatch(setCurrVerifyStep(0));
    dispatch(setEmail(""));
    dispatch(setPhone(""));
    dispatch(setPanfront(null));
    dispatch(setPanfrontBinary(""));
    dispatch(setPanNumber(""));
    dispatch(setCustomersId(""));
    dispatch(setadhaarFront(null));
    dispatch(setadhaarFrontBinary(""));
    dispatch(setadhaarBack(null));
    dispatch(setadhaarBackBinary(""));
    dispatch(setAadharNumber(""));
    dispatch(setCanceledCheque(null));
    dispatch(setCanceledChequeBinary(""));
    dispatch(setAccountNo(""));
    dispatch(setAccountNoRe(""));
    dispatch(setBankName(""));
    dispatch(setIrfcCode(""));
    dispatch(setCustomersId(""));
    if (location?.state?.pathName === "ContactPage") {
      navigate(`/customerdetails/${localStorage.getItem("ApplicationId")}`);
    } else if (naviagte) navigate("/lead/contacts");
    else setCurrentStep(currentStep + 1);
  };
  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const updateConsent = (val: boolean) => {
    dispatch(setNameConsent(val));
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 setCurrentStep={setCurrentStep} />;
      case 3:
        return <Step3 />;
      // case 4:
      //   return <Step4 />;
      case 4:
        return <Step5 />;
      // Add more cases for additional steps
      default:
        return null;
    }
  };

  return (
    <>
      {confirmCancel && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.6" }}
          className="fixed top-0 left-0 z-50 h-screen w-[100vw] flex justify-center items-center"
        >
          {" "}
          <Cancel
            title="Are You Sure You Want To Cancel This Customer Registration?"
            setConfirmCancel={setConfirmCancel}
            handleCancel={handleonCancel}
          />{" "}
        </div>
      )}
      <FormPopup
        defaultValue={type === "PAN" ? PanNumber : AadharNumber}
        entityType="customer"
        onSubmit={type === "PAN" ? step2fallback : step3fallback}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        type={type}
      />
      {showaadhaarpopup && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-50 h-screen w-[100vw] flex justify-center items-center"
        >
          <Aadhaarpopup
            setCurrentStep={setCurrentStep}
            setShowaadhaarpopup={setShowaadhaarpopup}
            aadhaarverifydetails={aadhaarverifydetails}
            registration_type="customer"
            isNameMismatch={
              (() => {
                // Get PAN name from Redux (stored in step 2 from result1.full_name)
                const panNameToCompare = pan_name
                  ? pan_name.toLowerCase().trim()
                  : verifypandetails.name?.toLowerCase()?.trim() || "";

                // Get Aadhaar name from popup state (from step 3 API response: adhaar.front.document_fields.name)
                const aadhaarNameToCompare = aadhaarverifydetails.name?.toLowerCase()?.trim() || "";

                // Only show mismatch if both names exist and are different
                return panNameToCompare !== "" &&
                  aadhaarNameToCompare !== "" &&
                  panNameToCompare !== aadhaarNameToCompare;
              })()
            }
            updateNameConsent={updateConsent}
            consent={name_consent}
            onClick={step4API}
            onNameMismatchUpdate={nameMismatchUpdateAPI}
          />
        </div>
      )}
      {showpanpopup && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-50 h-screen w-[100vw] flex justify-center items-center"
        >
          <Panpopup
            setCurrentStep={setCurrentStep}
            setShowpanpopup={setShowpanpopup}
            verifypandetails={verifypandetails}
          />
        </div>
      )}
      {loading && <Spinner />}
      <div className="p-4 bg-gray-100 flex flex-col h-screen font-inter items-start justify-start mx-auto w-auto sm:w-full md:w-full">
        <div className="flex md:flex-col flex-col gap-4 md:gap-5 items-start justify-start w-full">
          <Navbar>
            <div className=" w-full flex justify-between">
              <div className=" flex gap-3 items-center">
                <Img
                  src="images/sidebar_img/remit.svg"
                  className="h-5"
                  alt=""
                />
                <div className="gap-2 flex flex-col">
                  <span className="text-sm font-semibold">
                    Customer Registration
                  </span>
                  <span className="text-xs font-normal text-[#999999]">
                    Register new customer with correct details
                  </span>
                </div>
              </div>
              <div className="flex gap-3">
                {/* <div className="gap-2.5 flex items-center">
                  <Img src="images/overview/wrench.svg" alt="" />
                  <span className="text-sm font-semibold text-blue-700">
                    Help
                  </span>
                </div> */}
                {currentStep !== 4 && (
                  <AlertDialog>
                    <AlertDialogTrigger>
                      <button className="rounded-lg py-[11px] px-4 border bg-gray-button-gray-lite border-gray-border-gray-lite">
                        Cancel
                      </button>
                    </AlertDialogTrigger>
                    <AlertDialogPortal>
                      <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                      <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-2xl animate-contentShow">
                        <AlertDialogHeader className="flex text-left gap-4 pt-8 pb-4 px-10 ">
                          <AlertDialogTitle className="font-bold text-xl leading-7 tracking-[2%] text-black-label">
                            Are you absolutely sure?
                          </AlertDialogTitle>
                          <AlertDialogDescription className="font-medium text-base leading-6 tracking-[2%] text-[#7E7E7E] ">
                            This action can not be undone. This will permanently
                            delete your progress and remove the actions
                            preformed.
                          </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                          <AlertDialogCancel
                            className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                            asChild
                          >
                            <button>Close</button>
                          </AlertDialogCancel>
                          <AlertDialogAction
                            className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                            asChild
                          >
                            <button className="" onClick={handleonCancel}>
                              Confirm
                            </button>
                          </AlertDialogAction>
                        </AlertDialogFooter>
                      </AlertDialogContent>
                    </AlertDialogPortal>
                  </AlertDialog>
                )}
              </div>
            </div>
          </Navbar>
          <div className="gap-5 w-full flex h-full flex-1 flex-grow">
            <div className=" bg-white-A700 p-5 rounded-xl flex flex-col gap-5 w-full">
              <Stepper
                steps={customerRegistrationSteps.map((val) => val.name)}
                currentStep={currentStep - 1}
              />
              {renderStep()}
              {currentStep !== 4 && (
                <div className="flex gap-3">
                  {currentStep !== 1 && (
                    <button
                      type="button"
                      onClick={handlePrevious}
                      className={`px-4 py-[11px] w-fit rounded-lg border border-blue-700 text-blue-700 ${true ? "" : "opacity-40"}`}
                    >
                      Previous
                    </button>
                  )}
                  <button
                    type="button"
                    onClick={handleNext}
                    className={`px-4 py-[11px] w-fit rounded-lg bg-blue-700 text-white-A700 ${true ? "" : "opacity-40"}`}
                  >
                    {currentStep === customerRegistrationSteps.length - 1
                      ? "Submit"
                      : "Next"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Toaster theme="dark" position="top-right" />
    </>
  );
};

export default CustomerRegistration;
